/* LL: civil dates are UTC calendar values; the current instant is shifted to SAST
 * (UTC+2, no daylight saving). No fulfilment defaults live in this module. */
(function () {
  'use strict';
  // LL: merchant copy comes from Liquid's JSON; values remain text, never HTML.
  const llText = (key, fallback, values = []) => {
    let copy;
    if (typeof document !== 'undefined') {
      const node = document.getElementById('LLCopy');
      if (node) {
        if (!node.llCopy) { try { node.llCopy = JSON.parse(node.textContent); } catch (_) { node.llCopy = {}; } }
        copy = node.llCopy[key];
      }
    }
    return String(copy == null ? fallback : copy).replace(/\[(\d+)\]/g, (token, n) => n <= values.length ? String(values[n - 1]) : token);
  };

  const DAY = 86400000;
  const names = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  const unavailable = llText("ll_js_delivery_estimate_delivery_estimates_are_not_availa", "Delivery estimates are not available yet. Please contact Lean Living for delivery details.");
  const key = date => date.toISOString().slice(0, 10);
  const add = (date, days) => new Date(date.getTime() + days * DAY);
  function parseConfig(raw) {
    const lines = value => String(value || '').split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    const parseDays = value => {
      const result = String(value || '').split(',').map(s => names.indexOf(s.trim().toLowerCase()));
      if (!result.length || result.includes(-1)) throw Error(unavailable);
      return [...new Set(result)];
    };
    const days = parseDays(raw.days);
    if (!days.length || days.includes(-1) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(raw.cutoff || '')) throw Error(unavailable);
    const range = fields => {
      if (![3, 4].includes(fields.length) || !fields[0] || !/^\d+$/.test(fields[1]) || !/^\d+$/.test(fields[2])) throw Error(unavailable);
      const min = Number(fields[1]), max = Number(fields[2]);
      if (!Number.isSafeInteger(min) || !Number.isSafeInteger(max) || min > max || max > 366) throw Error(unavailable);
      return { label: fields[0], min, max, days: fields[3] ? parseDays(fields[3]) : days };
    };
    const zones = lines(raw.zones).map(line => {
      const fields = line.split('|').map(s => s.trim()), bounds = fields.shift();
      if (!/^\d{4}-\d{4}$/.test(bounds)) throw Error(unavailable);
      const [from, to] = bounds.split('-').map(Number);
      if (from > to) throw Error(unavailable);
      return { from, to, ...range(fields) };
    });
    if (!zones.length) throw Error(unavailable);
    const holidays = new Set(lines(raw.holidays));
    for (const date of holidays) {
      const parsed = new Date(date + 'T00:00:00Z');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(+parsed) || key(parsed) !== date) throw Error(unavailable);
    }
    return { days, cutoff: raw.cutoff, cutoffMinutes: Number(raw.cutoff.slice(0, 2)) * 60 + Number(raw.cutoff.slice(3)), zones, fallback: String(raw.default || '').trim() ? range(raw.default.split('|').map(s => s.trim())) : null, holidays };
  }
  function estimate(config, postal, now = new Date()) {
    if (!/^\d{4}$/.test(postal)) throw Error(llText("ll_js_delivery_estimate_please_enter_a_four_digit_south_a", "Please enter a four-digit South African postal code."));
    const zone = config.zones.find(z => Number(postal) >= z.from && Number(postal) <= z.to) || config.fallback;
    if (!zone) throw Error(llText("ll_js_delivery_estimate_we_do_not_have_an_estimate_for_th", "We do not have an estimate for this postal code yet. Please contact Lean Living."));
    const sast = new Date(now.getTime() + 2 * 3600000);
    let dispatch = new Date(Date.UTC(sast.getUTCFullYear(), sast.getUTCMonth(), sast.getUTCDate()));
    if (sast.getUTCHours() * 60 + sast.getUTCMinutes() >= config.cutoffMinutes) dispatch = add(dispatch, 1);
    let attempts = 0;
    const dispatchDays = zone.days || config.days;
    while (!dispatchDays.includes(dispatch.getUTCDay()) || config.holidays.has(key(dispatch))) {
      dispatch = add(dispatch, 1);
      if (++attempts > 3660) throw Error(unavailable);
    }
    const business = count => {
      let date = dispatch, remaining = count, guard = 0;
      // Zero-day transit still cannot promise weekend/holiday delivery.
      while (remaining > 0 || date.getUTCDay() === 0 || date.getUTCDay() === 6 || config.holidays.has(key(date))) {
        date = add(date, 1);
        if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !config.holidays.has(key(date))) remaining = Math.max(0, remaining - 1);
        if (++guard > 3660) throw Error(unavailable);
      }
      return date;
    };
    let start = business(zone.min), end = business(zone.max);
    // Far routes run Monday/Tuesday and must finish in the dispatch week.
    if (dispatchDays.every(day => day === 1 || day === 2) && dispatchDays.includes(2)) {
      const wednesday = add(dispatch, 3 - dispatch.getUTCDay());
      let friday = add(dispatch, 5 - dispatch.getUTCDay());
      while (config.holidays.has(key(friday)) && friday >= wednesday) friday = add(friday, -1);
      if (start < wednesday) start = wednesday;
      while (config.holidays.has(key(start)) && start <= friday) start = add(start, 1);
      if (end > friday) end = friday;
      // Do not invert a window or promise delivery on a holiday.
      if (start > end) throw Error(llText("ll_js_delivery_estimate_please_contact_lean_living_to_con", "Please contact Lean Living to confirm delivery during this holiday week."));
    }
    return { dispatch, start, end, label: zone.label, cutoff: config.cutoff };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { parseConfig, estimate, key };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('ll-delivery-estimate')) return;
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.result = this.querySelector('[role="status"]');
      if (!this.form || this.submit) return;
      try { const saved = localStorage.getItem('ll-delivery-postal'); if (/^\d{4}$/.test(saved)) this.input.value = saved; } catch (_) { /* Storage is optional. */ }
      this.submit = event => {
        event.preventDefault();
        this.result.replaceChildren();
        this.input.removeAttribute('aria-invalid');
        const postal = this.input.value.trim();
        try {
          if (!/^\d{4}$/.test(postal)) {
            this.input.setAttribute('aria-invalid', 'true');
            this.input.focus();
            throw Error(llText("ll_js_delivery_estimate_please_enter_a_four_digit_south_a", "Please enter a four-digit South African postal code."));
          }
          const value = estimate(parseConfig(this.dataset), postal);
          try { localStorage.setItem('ll-delivery-postal', postal); } catch (_) { /* Storage is optional. */ }
          const format = (date, weekday) => new Intl.DateTimeFormat('en-ZA', { timeZone: 'UTC', weekday, day: 'numeric', month: 'short', year: 'numeric' }).format(date);
          const bold = text => { const node = document.createElement('strong'); node.textContent = text; return node; };
          this.result.append(llText("ll_js_delivery_estimate_order_before", "Order before "), bold(value.cutoff + llText("ll_js_delivery_estimate_on", " on ") + format(value.dispatch, 'long')), llText("ll_js_delivery_estimate_south_african_time_and_we_dispatc", " (South African time) and we dispatch on "), bold(format(value.dispatch, 'long')), llText("ll_js_delivery_estimate_estimated_delivery", ". Estimated delivery: "), bold(format(value.start, 'short') + (key(value.start) === key(value.end) ? '' : ' – ' + format(value.end, 'short'))), ' (' + value.label + ').');
        } catch (error) { this.result.textContent = error.message; }
      };
      this.form.addEventListener('submit', this.submit);
    }
    disconnectedCallback() { if (this.submit) this.form.removeEventListener('submit', this.submit); this.submit = null; }
  }
  customElements.define('ll-delivery-estimate', DeliveryEstimate);
})();
